export default __webpack_public_path__ + "static/media/remy_login.ad21ec28.png";